import { Loading, Message, MessageBox } from 'element-ui';
import axios from 'axios';
import router from '@/router';
// 创建axios实例
const request = axios.create({
  baseURL: process.env.VUE_APP_API_PREFIX + '/product-service',
  headers: {
    'Content-Type': 'application/json',
  },
});
// request 拦截器
request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    // headers 里放还是data放 Bearer 是否存在 key Authorization 看怎么修改
    if (token) {
      // config.headers['Authorization'] = 'Bearer ' + token
      config.headers['Authorization'] = token;
    }
    // config.timeout = store.state.timeOut;
    if (!(config.data && config.data.hideLoading))
      window.loadingInstance = Loading.service({
        lock: true,
        text: 'loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
    if (!config.data) {
      config.data = {};
    }
    return config;
  },
  (error) => {
    if (window.loadingInstance) window.loadingInstance.close();
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000,
    });
    Promise.reject(error);
  }
);
request.interceptors.response.use(
  (response) => {
    if (window.loadingInstance) window.loadingInstance.close();
    const res = response.data;
    if (typeof res.success != 'undefined') {
      if (!res.success) {
        //登录失效
        if (res.errorCode == '00000003') {
          localStorage.removeItem('token');
          MessageBox.confirm(
            'Your login status has expired. Please log in again',
            'Confirm logout',
            {
              confirmButtonText: 'Login again',
              cancelButtonText: 'cancel',
              type: 'warning',
            }
          ).then(() => {
            // this.$router.push({ name: 'Login' });
            router.replace({ path: '/Login' });
            console.log(11111);
            // 调用登出接口
            localStorage.clear();
          });
        } else {
          // 失败
          Message({
            message: res.errorMessage,
            type: 'error',
            duration: 5 * 1000,
          });
        }
        return Promise.reject('error');
      } else {
        // 成功
        return res.data || res.result;
      }
    } else {
      if (res.code != 0) {
        //1

        if (res.code === '00000003') {
          localStorage.removeItem('token');
          MessageBox.confirm(
            'Your login status has expired. Please log in again',
            'Confirm logout',
            {
              confirmButtonText: 'Login again',
              cancelButtonText: 'cancel',
              type: 'warning',
            }
          ).then(() => {
            console.log(2222);
            router.push({ path: '/Login' });
          });
        } else {
          Message({
            message: res.msg,
            type: 'error',
            duration: 5 * 1000,
          });
        }

        return Promise.reject('error');
      } else {
        if (JSON.stringify(res.data) == '{}' || !res.data) {
          // Message({
          //   message: res.msg,
          //   type: 'success',
          //   duration: 3 * 1000,
          // })
        } else {
          return res.data; //3
        }
      }
    }
  },
  (error) => {
    if (window.loadingInstance) window.loadingInstance.close();
    Message({
      message: error.response.data.msg,
      type: 'error',
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);
export default request;
